import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";

import BIMClass from "./BIMClass.graphql";
import { taxonomy } from "../../api";

export default function useBIMClass(id: string) {
    return useQuery(
        gql(BIMClass),
        {
            client: taxonomy,
            skip: id === undefined,
            variables: {
                id,
            },
        },
    );
}
